import React, {useEffect, useState} from 'react';
import {Button, ListGroup} from "react-bootstrap";
import {Link} from "react-router-dom";
import {ROUTES} from "../../../helpers/routeConsts";
import {StatusClass, StatusText} from "../../../components/modals/ResumeVacancyStepsModal";
import moment from "moment/moment";
import ResumeComments from "./comment-resume";
import {candidateHooks} from "../../../api/candidate.api";
import {DownloadPdfCard} from "../../../components/download-pdf-card";
import {IVacancyCard} from '../../../api/type/card-candidate-type';

const InfoCardCandidate = ({candidateId, isNeedDownload = false, vacancyId}: { candidateId: number, isNeedDownload?: boolean, vacancyId?: number }) => {
  const { data: candidateCardInfoRaw  = [] } = candidateHooks.useCardCandidateInfo(Number(candidateId));

  const sortByIdFirst = (candidateCardInfo: IVacancyCard[], vacancyId?: number) => {
    if (!vacancyId) return candidateCardInfo;
    return candidateCardInfo.sort((a, b) => (a.id === vacancyId ? -1 : b.id === vacancyId ? 1 : 0));
  };

  const candidateCardInfo = sortByIdFirst([...candidateCardInfoRaw], vacancyId);

  const [openItems, setOpenItems] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    if (candidateCardInfo?.length && Object.keys(openItems).length === 0) {
      setOpenItems({
        [candidateCardInfo[0].id]: true,
      });
    }
  }, [candidateCardInfo]);


  const toggleOpen = (id: number) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  if (!candidateCardInfo || candidateCardInfo?.length < 1) {
    return <div className="white-form-block">Кандидат не участвует в вакансиях </div>
  }

  return (
      <div className="white-form-block">
        <ListGroup>
          {candidateCardInfo?.map(vacancy => (
              <ListGroup.Item key={vacancy.id} className="mb-4 p-4 border rounded-lg shadow-md hover:bg-gray-50">
                <div className={'flex gap-4 items-center justify-between'}>
                  <Link to={ROUTES.VACANCY_INFO + '/' + vacancy.id} className="block text-gray-800 hover:text-blue-600">
                    <div className="text-lg font-semibold mb-2">Вакансия: {vacancy.position}</div>
                  </Link>
                  <Button onClick={() => toggleOpen(vacancy.id)} className="px-2 cursor-pointer flex justify-between items-center">
                    {openItems[vacancy.id] ? (
                        <i className="bi bi-chevron-up text-gray-500" style={{ fontSize: '11px' }} />
                    ) : (
                        <i className="bi bi-chevron-down text-gray-500" style={{ fontSize: '11px' }} />
                    )}
                  </Button>
                </div>

                {openItems[vacancy.id] && (
                    <div className="space-y-4">
                      {vacancy.resumes?.map(resume => (
                          <div key={resume.id} className="border-t pt-4">
                            {/* Резюме */}
                            <div className="text-lg font-semibold mb-2">Резюме: {resume?.name}</div>

                            {/* Этапы */}
                            <div className="mt-1">
                              <div className="text-sm font-semibold text-gray-600 mb-2">Этапы:</div>

                              <div className="space-y-5">
                                <div className="space-y-2">
                                  {resume.candidateVacancySteps?.map(step => {
                                    const statusKey = step.complete ? 'complete' : step.failed ? 'failed' : step.isCome ? 'isCome' : 'default';
                                    return (
                                        <div key={step.id} className="text-sm flex gap-4 text-gray-500">
                                          {/* Название этапа */}
                                          <span className="font-medium w-1/2">{step.nameStep || step.step.name}</span>

                                          {/* Статус этапа */}
                                          <span className={`w-1/3 ${StatusClass[statusKey]}`}>
                                {StatusText[statusKey]}
                              </span>

                                          {/* Дата завершения этапа */}
                                          <span
                                              className="font-medium w-1/4 text-right">{step.dateEnd && moment(step.dateEnd).format('HH:mm DD.MM.YYYY')}</span>
                                        </div>
                                    );
                                  })}
                                </div>

                                <ResumeComments resumeId={resume.id} vacancyId={vacancy.id}/>
                              </div>
                            </div>
                          </div>
                      ))}

                    </div>
                )}

              </ListGroup.Item>
          ))}
        </ListGroup>
        {isNeedDownload && (
          <div className={'flex justify-end'}>
            <DownloadPdfCard candidateId={Number(candidateId)}/>
          </div>
        )}

      </div>
  );
};

export default InfoCardCandidate;